import { CommonModule }                      from '@angular/common';
import { NgModule }                          from '@angular/core';
import { ListOperationsListHeaderComponent } from '@shared/list-operations/components/list-operations-list-header/list-operations-list-header.component';
import { PaginationModule }                  from '@shared/list-operations/components/pagination/pagination.module';


@NgModule( {
	declarations: [
		ListOperationsListHeaderComponent
	],
	exports: [
		ListOperationsListHeaderComponent
	],
	imports: [
		// Angular
		CommonModule,

		// ListOperations
		PaginationModule
	]
} )
export class ListOperationsListHeaderModule {}
